import { z } from 'zod';

import { MediaKind, mediaSchema } from '../media';
import { mongoIdSchema } from '../shared';

//////////////////////////
// List
export const listReqSchema = z.object({
  params: z.object({}).nullish(),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type ListReq = z.infer<typeof listReqSchema>;

export const listResSchema = {
  200: z.object({
    data: z.array(mediaSchema),
  }),
};
export type ListRes = z.infer<(typeof listResSchema)[200]>;

// GetByRefDoc
export const getByRefDocReqSchema = z.object({
  params: z.object({
    id: mediaSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type GetByRefDocReq = z.infer<typeof getByRefDocReqSchema>;

export const getByRefDocResSchema = {
  200: z.object({
    data: z.array(mediaSchema),
  }),
};
export type GetByRefDocRes = z.infer<(typeof getByRefDocResSchema)[200]>;

// GetById
export const getByIdReqSchema = z.object({
  params: z.object({
    id: mediaSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type GetByIdReq = z.infer<typeof getByIdReqSchema>;

export const getByIdResSchema = {
  200: z.object({
    data: mediaSchema,
  }),
};
export type GetByIdRes = z.infer<(typeof getByIdResSchema)[200]>;

// Create
const fileSchema = z
  .object({
    lastModifiedDate: z.date(),
    filepath: z.string(),
    newFilename: z.string(),
    originalFilename: z.string(),
    mimetype: z.string(),
    size: z.number(),
  })
  .strip();
export const createMediaReqSchema = z.object({
  params: z.object({}).nullish(),
  query: z.object({}).nullish(),
  body: z.object({
    refDocId: mongoIdSchema,
    organizationId: mongoIdSchema,
    kind: z.enum([
      MediaKind.ProductImage,
      MediaKind.ProductDocument,
      MediaKind.ContentImage,
      MediaKind.ContentDocument,
    ]),
  }),
  files: z.object({
    file: z.union([fileSchema, z.array(fileSchema)]),
  }),
});
export type CreateMediaReq = z.infer<typeof createMediaReqSchema>;

export const createMediaResSchema = {
  200: z.object({
    data: z.array(mediaSchema),
  }),
};
export type CreateMediaRes = z.infer<(typeof createMediaResSchema)[200]>;

// Delete
export const deleteMediaReqSchema = z.object({
  params: z.object({
    id: mediaSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type DeleteMediaReq = z.infer<typeof deleteMediaReqSchema>;

export const deleteMediaResSchema = {
  200: z.object({}),
};
export type DeleteMediaRes = z.infer<(typeof deleteMediaResSchema)[200]>;
